/**
 * @module paramsToJSON
 */
const { toType } = require('./toType');

/**
 * Convert params object to JSON encoded string.
 *
 * @param {object} params - A params object.
 *
 * @throws {Error} - Throws an error if `params` is not an object.
 *
 * @returns {string} - The JSON encoded string.
 */
function paramsToJSON(params) {
  if (!params) {
    return '';
  }
  if (toType(params) !== 'object') {
    throw new Error('Supplied `params` must be an object.');
  }
  return JSON.stringify(params);
}

module.exports = {
  paramsToJSON,
};
